import type { Card } from './types'

export const SUIT_SYMBOL: Record<string, string> = {
  S: '♠', H: '♥', D: '♦', C: '♣',
}

export const isRed = (suit: string) => suit === 'H' || suit === 'D'

/** Short display rank — same as rank for most, but 10 stays '10' */
export const displayRank = (rank: string) => rank

/** Baccarat value of a card (A=1, 2-9=face, 10/J/Q/K=0) */
export const baccaratValue = (card: Card) => card.value % 10

/** Sum of baccarat values for a hand */
export const bacSum = (cards: Card[]) =>
  cards.reduce((s, c) => s + c.value, 0)

/** Chip denominations with colors */
export const CHIPS = [
  { value: 5,    color: '#ef4444', label: '5'    },
  { value: 10,   color: '#3b82f6', label: '10'   },
  { value: 25,   color: '#8b5cf6', label: '25'   },
  { value: 50,   color: '#f59e0b', label: '50'   },
  { value: 100,  color: '#10b981', label: '100'  },
  { value: 500,  color: '#ec4899', label: '500'  },
]

export const fmtCoins = (n: number) => n.toLocaleString('en-IN')
